import { logger } from "@/services/monitoring/logger";

type PendoQueueFn = (...args: unknown[]) => void;

interface PendoAgent {
  _q: unknown[][];
  initialize: PendoQueueFn;
  identify: PendoQueueFn;
  updateOptions: PendoQueueFn;
  pageLoad: PendoQueueFn;
  track: PendoQueueFn;
  trackAgent: PendoQueueFn;
}

declare global {
  interface Window {
    pendo?: PendoAgent;
  }
}

//this is a public app api key. it has write only permissions and could only be used to pollute our data.
//At some point in the future we might want to implement a method of signing requests with JWTs, but this will still be public...
const PENDO_API_KEY = "30c47764-b839-4f1a-a3f0-846c08aeadc5";

let pendoInitialized = false;

const PENDO_METHODS = [
  "initialize",
  "identify",
  "updateOptions",
  "pageLoad",
  "track",
  "trackAgent",
] as const;

//This installs the Pendo agent stub supplied by Pendo: it queues calls until the real agent script loads.
function installPendoAgent(): PendoAgent {
  const pendo: PendoAgent = (window.pendo ??= {} as PendoAgent);
  pendo._q ??= [];

  for (const method of PENDO_METHODS) {
    if (!pendo[method]) {
      pendo[method] = (...args: unknown[]) => {
        pendo._q[method === PENDO_METHODS[0] ? "unshift" : "push"]([method, ...args]);
      };
    }
  }

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://cdn.pendo.io/agent/static/${PENDO_API_KEY}/pendo.js`;
  const firstScript = document.getElementsByTagName("script")[0];
  firstScript?.parentNode?.insertBefore(script, firstScript);

  return pendo;
}

export function registerPendo(principalId: string, portfolioId: number) {
  try {
    const pendo = installPendoAgent();

    // This creates visitors and accounts in Pendo.
    // Use Strings, Numbers, or Bools for value types.
    pendo.initialize({
      visitor: {
        id: principalId, // Required if user is logged in
      },
      account: {
        id: portfolioId, // Highly recommended, required if using Pendo Feedback or OEM Adopt
      },
    });

    pendoInitialized = true;
    logger.info("Pendo registered successfully.");
  } catch (e) {
    logger.warn("failed to register Pendo. ", e);
  }
}

export function isPendoInitialized() {
  return pendoInitialized;
}
